import React, {useCallback} from "react";
import {IncidentFeedForm} from "./incident-feed-form";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {apiV2} from "@/api/axiosConfig";

export function NewIncidentFeed() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const prevUrl = searchParams.get("prev") ?? "/incident-feeds";

    const handleSubmit = useCallback(async (data: {
        clientID?: string;
        name: string;
        type: string;
        reference: string;
        isDefault: boolean;
    }) => {
        try {
            await apiV2.post("incident-feeds", data);
            navigate(prevUrl);
        } catch (error) {
            console.error("Failed to create incident feed:", error);
            alert("Failed to create incident feed");
            throw error;
        }
    }, [navigate]);

    const handleCancel = useCallback(() => {
        navigate(prevUrl);
    }, [navigate, prevUrl]);

    return (
        <div>
            <nav className="flex items-center gap-2 text-sm text-light-grey mb-4">
                <Link to="/sites" className="hover:text-grey">Sites</Link>
                <span>&gt;</span>
                <Link to={prevUrl} className="hover:text-grey">Incident Feeds</Link>
                <span>&gt;</span>
                <span className="text-grey">Create Incident Feed</span>
            </nav>
            <IncidentFeedForm
                mode="create"
                onSubmit={handleSubmit}
                onCancel={handleCancel}
            />
        </div>
    );
}
